import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  TextField,
} from '@mui/material'
import { useGlobalContext } from '../../Contexts/GlobalTriggers'
import PageSection from '../../Constants&Theme/PageSection'

const SampleFind = () => {
  const { playScanSound } = useGlobalContext()
  const navigate = useNavigate()
  const [sampleID, setSampleID] = useState<string>('')

  return (
    <Box
      sx={{
        maxWidth: 'sm',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <PageSection title={'Find Sample'}>
        <form
          onSubmit={(e: any) => navigate(`/stuart/sample/info/${sampleID}`)}
          // noValidate
          style={{ width: '100%' }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: 1,
            }}
          >
            <FormControl fullWidth>
              <TextField
                autoFocus
                label="Sample ID"
                onChange={(e) => {
                  playScanSound(true)
                  setSampleID(e.target.value)
                }}
                fullWidth
              />
              <FormHelperText>
                Scan or enter the Sample ID such as SA01010
              </FormHelperText>
            </FormControl>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ m: 2 }}
            >
              Find Sample
            </Button>
          </Box>
        </form>
      </PageSection>
    </Box>
  )
}

export default SampleFind
